import { commitMutation, graphql } from 'react-relay';

const mutation = graphql`
  mutation AmazonPayPayloadMutation($input: AmazonPayPayloadInput!) {
    amazonPayPayload(input: $input) {
      payload,
      signature,
      publicKeyId
    }
  }
`;

function commit(environment, orderId, callback) {
  return commitMutation(environment, {
    mutation,
    variables: {
      input: {
        orderId
      }
    },
    onCompleted: (response, errors) => {
      if (errors) {
        callback && callback(errors[0]);
      } else {
        callback && callback(null, response.amazonPayPayload);
      }
    },
    onError: err => {
      callback && callback(err);
    },
  });
}

export default { commit };
